import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ChevronLeft } from 'lucide-react';

export default function TermsOfService() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <div className="p-4 md:p-8">
        <div className="mx-auto max-w-2xl">
          <div className="mb-8 flex items-center gap-3">
            <Button variant="ghost" size="icon" onClick={() => navigate(-1)}>
              <ChevronLeft className="h-5 w-5" />
            </Button>
            <h1 className="text-2xl font-bold text-foreground" style={{ fontFamily: "'Playfair Display', serif" }}>
              Terms of Service
            </h1>
          </div>

          <div className="prose prose-sm max-w-none text-muted-foreground space-y-4">
            <p className="text-sm text-muted-foreground">Last updated: {new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</p>

            <h2 className="text-lg font-semibold text-foreground">1. Acceptance of Terms</h2>
            <p>By accessing and using My Garden Assistant, you agree to be bound by these Terms of Service. If you do not agree, please do not use the application.</p>

            <h2 className="text-lg font-semibold text-foreground">2. Description of Service</h2>
            <p>My Garden Assistant is a gardening planning application that helps you manage plants, generate growing schedules, and track gardening tasks. We offer both free and paid subscription plans.</p>

            <h2 className="text-lg font-semibold text-foreground">3. User Accounts</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>You must provide accurate information when creating an account.</li>
              <li>You are responsible for maintaining the security of your account credentials.</li>
              <li>You must be at least 16 years old to use the service.</li>
            </ul>

            <h2 className="text-lg font-semibold text-foreground">4. Free and Pro Plans</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong className="text-foreground">Free Plan:</strong> Limited to 5 plants with basic schedule generation.</li>
              <li><strong className="text-foreground">Pro Plan:</strong> Unlimited plants, full schedule generation, all plant types, and priority support.</li>
            </ul>

            <h2 className="text-lg font-semibold text-foreground">5. Payments and Subscriptions</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>Pro subscriptions are billed monthly or annually through Paddle, our payment provider.</li>
              <li>Prices are displayed in GBP and include applicable taxes.</li>
              <li>Subscriptions auto-renew unless cancelled before the end of the billing period.</li>
              <li>You can cancel your subscription at any time through the subscription management portal.</li>
            </ul>

            <h2 className="text-lg font-semibold text-foreground">6. User Content</h2>
            <p>You retain ownership of any content you create (plant notes, garden data). By using the service, you grant us a licence to store and process this content to provide the service.</p>

            <h2 className="text-lg font-semibold text-foreground">7. Acceptable Use</h2>
            <p>You agree not to misuse the service, including attempting to access other users' data, reverse-engineer the application, or use automated systems to access the service.</p>

            <h2 className="text-lg font-semibold text-foreground">8. Disclaimer</h2>
            <p>Gardening advice and schedules are provided for informational purposes only. Results may vary based on local conditions, weather, and other factors. We are not liable for crop outcomes.</p>

            <h2 className="text-lg font-semibold text-foreground">9. Limitation of Liability</h2>
            <p>To the maximum extent permitted by law, My Garden Assistant shall not be liable for any indirect, incidental, or consequential damages arising from your use of the service.</p>

            <h2 className="text-lg font-semibold text-foreground">10. Changes to Terms</h2>
            <p>We may update these terms from time to time. Continued use of the service after changes constitutes acceptance of the updated terms.</p>

            <h2 className="text-lg font-semibold text-foreground">11. Governing Law</h2>
            <p>These terms are governed by the laws of England and Wales.</p>

            <h2 className="text-lg font-semibold text-foreground">12. Contact</h2>
            <p>If you have questions about these Terms, please contact us through the application.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
